import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      windowWidth: window.innerWidth
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapGetters({
      event: 'event/GET_CURRENT_EVENT'
    }),
    isMobile () {
      return this.windowWidth < 760
    },
    $premiumPrice () {
      const lang = this.$i18n ? this.$i18n.locale : (navigator.language || '')
      if (lang.startsWith('fr')) return { label: '99\u20AC', amount: 99, currency: 'eur' }
      return { label: '400\u20AA', amount: 400, currency: 'ils' }
    }
  },
  methods: {
    resizeImage (url, width) {
      const modifiedUrl = url.replace(/photos\//, `photos-resized/w${width}-`)
      console.log('Inside resize -  url, width', url, width)
      return modifiedUrl
    },
    handleResize () {
      console.log('Inside handleResize', window.innerWidth)
      this.windowWidth = window.innerWidth
    }
  }
}
